/**
 * Vendor-branding defaults.
 *
 * This file once built the global MUI theme; the app now styles itself with
 * Tailwind tokens (src/styles/tailwind.source.css). What remains are the
 * default values a vendor's config falls back to before their own branding
 * loads — they seed the settings redux state and the visualizer preview.
 */
export const defaultPrimaryColor = '#0052cc'
export const defaultSecondaryColor = '#edf2ff'
export const defaultTextSecondaryColor = '#000000'
export const defaultFonts = `"Lexend", "Arial", sans-serif`
export const defaultLogo = `https://ardealy.com/wp-content/uploads/2023/05/wpWhiteLogo.png`
